import React from 'react';
import numericFunction from "../../../utils/NumericFunction";
import {formatToPersianAddComma} from "../../../utils/CommaSeparator";

const PrintType7Footer = ({data}) => {
  return (
    <div className={"footerPrintType7"}>
      <div className={"row2 d-flex flex-wrap align-items-center"}>
        {data.headerAndFooter.footer.map((v, index) => {
          // تلفن و موبایل نمیخواد جدا بشه ارقامش
          if (v.id === 'Memo12' || v.id === 'Memo13' || v.id === "Memo72") {
            return <div
              key={index}
              style={v.style ? v.style : {}}
              className={"mx-4 my-1"}
            >
              {v.label}: {numericFunction.e2p(v.value)}
            </div>
          } else {
            if (v.value === "") {
              return <div
                key={index}
                className={"mx-4 my-1"}
                style={v.style ? v.style : {}}
              >{v.label}: {v.value}</div>
            } else {
              return <div
                key={index}

                className={"mx-4 my-1"}
                // style={{flex: (100 / data.headerAndFooter.footer.length)}}
              >{v.label}: {(v.value)}</div>
            }

          }

        })}
      </div>
    </div>

  );
};

export default PrintType7Footer;
